import { environment } from '@env/environment';

export class WebServiceEndpoints {
  public static apiServiceBaseUrl: string = WebServiceEndpoints.getApiUrl();

  static Herald = class {
    public static version(componentName: string): string {
      return `${WebServiceEndpoints.apiServiceBaseUrl}/${componentName}/version`;
    }

    public static ping(componentName: string): string {
      return `${WebServiceEndpoints.apiServiceBaseUrl}/${componentName}/ping`;
    }
  };

  static Specialist = class {
    public static setSkills = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/setskills`;
    public static accessToken = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/specialist/access-token`;
    public static capabilityToken = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/capability-token`;
    public static token = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/token`;
    public static getActivities = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/activities`;
    public static skills = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/specialist/skills`;
    public static getAvailability = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/info`;
    public static setAvailability = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/availability/change`;
    public static getAvailabilityByIds = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/availability`;
  };

  static Skills = class {
    public static get = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/skills`;
  };

  static Call = class {
    public static call = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/call`;
    public static endCall = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/call/end`;
    public static resolveCall = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/call/resolve`;
    public static getCallsHistory = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/calls`;
    public static getRecordDownloadUrl = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/recordings/signed-url`;
    public static inviteBySms = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/invite/by-sms`;
    public static joinBySessionId = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/call/join/by-session-id`;
    public static getSessionInfo = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/call/session/info`;
    public static getSettings = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/settings`;
  };

  static Settings = class {
    public static config = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/settings`;
    public static authorize = `${WebServiceEndpoints.apiServiceBaseUrl}/api/authorize`;
    public static refreshCCToken = `${WebServiceEndpoints.apiServiceBaseUrl}/api/token/refresh`;
    public static decryptCCToken = `${WebServiceEndpoints.apiServiceBaseUrl}/api/token/decrypt`;
  };

  static Deeplink = class {
    public static callBySession = `${WebServiceEndpoints.apiServiceBaseUrl}/api/deeplink`;
  };

  static Log = class {
    public static write = `${WebServiceEndpoints.apiServiceBaseUrl}/api/log`;
  };

  static User = class {
    public static globalSignOut = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/global-sign-out`;
  };

  static Admin = class {
    public static getUsers = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/list`;
    public static createUser = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/create`;
    public static editUser = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/update`;
    public static getUserPoolSettings = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/settings`;
    public static deleteUser = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/delete`;
    public static enableUser = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/user/enable`;
    public static getSignedUrl = `${WebServiceEndpoints.apiServiceBaseUrl}/configuration/signed-url`;
  };

  static Docusign = class {
    public static getAuthorizationUri = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/docusign/authorization-uri`;
    public static enroll = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/docusign/user`;
    public static getTemplates = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/docusign/templates`;
    public static createEnvelopeAndView = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/docusign/envelope-and-view/create`;
    public static createRecipientView = `${WebServiceEndpoints.apiServiceBaseUrl}/videochat/docusign/recipient-view/create`;
  };

  static LiveChat = class {
    public static getAccessToken = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/token`;
    public static joinChannel = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/join`;
    public static acceptTask = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/task/accept`;
    public static setIsOnlineStatus = `${WebServiceEndpoints.apiServiceBaseUrl}/taskrouting/specialist/online`;
    public static getMessages = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/messages`;
    public static sendMessage = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/messages/add`;
    public static sendSystemMessage = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/messages/system/add`;
    public static setChannelAttributes = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/attributes`;
    public static getSettings = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/settings`;
    public static getHistory = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/chats/csv`;
  };

  static Incognito = class {
    public static getTask = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/channel/task`;
    public static joinChannel = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/user/supervision-mode/join`;
    public static leaveChannel = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/user/supervision-mode/leave`;
    public static joinTraining = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/user/training-mode/join`;
    public static leaveTraining = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/user/training-mode/leave`;
    public static takeOver = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/user/training-mode/takeover`;
  };

  static AnonymousLiveChat = class {
    public static sendMessage = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/web/channel/messages/add`;
    public static sendSystemMessage = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/web/channel/messages/system/add`;
    public static getMessages = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/web/channel/messages`;
    public static getMemberInfo = `${WebServiceEndpoints.apiServiceBaseUrl}/livechat/web/channel/customer/info`;
  };

  static VideoAndLiveChatCryptography = class {
    public static decrypt = `${WebServiceEndpoints.apiServiceBaseUrl}/api/cryptography/decrypt`;
  };

  private static getApiUrl(): string {
    let url = window['apiUrl'];
    if (environment.qaEnv) {
      url = window['qaEnvApiUrl'];
    } else if (environment.dev01) {
      url = window['dev01ApiUrl'];
    }

    if (!url) {
      throw new Error('Provide API url in src/fi-agent-settings.ts file');
    }
    return url;
  }
}
